import { useCallback, useEffect, useState } from "react";
import { useFetch } from "@common/hook/useFetch";
import { ITerminationRequestResponse } from "@pages/CancelBroadband/interface/ITerminationRequestResponse";
import { getTerminationRequestApiRoute } from "@api-routes/bff";
import { isObject } from "@utils/object";

export const useCancelBroadbandPage = () => {
    const [getTerminationRequestState, { get }] = useFetch();
    const [terminationRequest, setTerminationRequest] = useState<ITerminationRequestResponse>();

    const getTerminationRequest = useCallback(() => {
        get<ITerminationRequestResponse>(getTerminationRequestApiRoute()).then((terminationRequestResponse) => {
            if (terminationRequestResponse && isObject(terminationRequestResponse)) {
                setTerminationRequest(terminationRequestResponse);
            } else {
                setTerminationRequest(undefined);
            }
        });
    }, [get]);

    useEffect(getTerminationRequest, [getTerminationRequest]);

    return {
        getTerminationRequestState,
        terminationRequest,
        getTerminationRequest,
    };
};
